import { useEffect, useRef, useState } from 'react';

import { copyToClipboard } from '@/utils/helper-utils';

export const useCopyFeedback = (text: string, options?: { onReset?: () => void; feedbackMs?: number }) => {
  const [copied, setCopied] = useState(false);

  const { onReset, feedbackMs = 2000 } = options || {};

  const copiedTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
      }
    };
  }, []);

  const copy = async () => {
    try {
      await copyToClipboard({ textContent: text });
      setCopied(true);

      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
      }

      copiedTimeoutRef.current = setTimeout(() => {
        setCopied(false);
        onReset?.();
        copiedTimeoutRef.current = null;
      }, feedbackMs);

      return true;
    } catch (error) {
      console.error('Failed to copy message:', error);
      return false;
    }
  };

  return { copied, copy };
};
